import {
  GetSegmentChangeHistoryRequestPayload,
  GetSegmentChangeHistoryResponse,
  SegmentChangeHistoryAnalyticsData,
} from 'types/segments/segments.types';

export const GET_SEGMENT_CHANGE_HISTORY_REQUEST =
  'GET_SEGMENT_CHANGE_HISTORY_REQUEST';
export const GET_SEGMENT_CHANGE_HISTORY_SUCCESS =
  'GET_SEGMENT_CHANGE_HISTORY_SUCCESS';
export const GET_SEGMENT_CHANGE_HISTORY_FAILURE =
  'GET_SEGMENT_CHANGE_HISTORY_FAILURE';

export const CLEAR_SEGMENT_CHANGE_HISTORY_SUCCESS =
  'CLEAR_SEGMENT_CHANGE_HISTORY_SUCCESS';

export interface GetSegmentChangeHistoryRequestAction {
  type: typeof GET_SEGMENT_CHANGE_HISTORY_REQUEST;
  payload: GetSegmentChangeHistoryRequestPayload;
  [key: string]: any;
}

export interface GetSegmentChangeHistorySuccessAction {
  type: typeof GET_SEGMENT_CHANGE_HISTORY_SUCCESS;
  payload: GetSegmentChangeHistoryResponse;
  [key: string]: any;
}

export interface GetSegmentChangeHistoryFailureAction {
  type: typeof GET_SEGMENT_CHANGE_HISTORY_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearSegmentChangeHistorySuccessAction {
  type: typeof CLEAR_SEGMENT_CHANGE_HISTORY_SUCCESS;
  [key: string]: any;
}

export type SegmentChangeHistoryActionTypes =
  | GetSegmentChangeHistoryRequestAction
  | GetSegmentChangeHistorySuccessAction
  | GetSegmentChangeHistoryFailureAction
  | ClearSegmentChangeHistorySuccessAction;

export interface SegmentChangeHistoryState {
  changeHistory: SegmentChangeHistoryAnalyticsData[];
  loading: boolean;
  error: string | null;
  success: boolean;
}
